import React from 'react'
import { ButtonGroup, ToggleButton } from 'react-bootstrap'
import { Icon } from '@ztechapps/webui.util'
import { useContext } from './Context'

import { ViewLayoutType } from '../../../config/types'

export const DesktopToggleViewLayoutButton = () => {
  const { viewLayout, setViewLayout } = useContext()

  return (
    <ButtonGroup size="sm" className="d-none d-lg-flex">
      <ToggleButton
        key={ViewLayoutType.list}
        id={`radio-${ViewLayoutType.list}`}
        type="radio"
        variant="outline-primary"
        name="toggleViewLayout"
        value={ViewLayoutType.list}
        checked={viewLayout === ViewLayoutType.list}
        onChange={(e) => setViewLayout(e.currentTarget.value as ViewLayoutType)}
      >
        <Icon name="list-ul" title="Click to view as list" />
      </ToggleButton>

      <ToggleButton
        key={ViewLayoutType.grid}
        id={`radio-${ViewLayoutType.grid}`}
        type="radio"
        variant="outline-primary"
        name="toggleViewLayout"
        value={ViewLayoutType.grid}
        checked={viewLayout === ViewLayoutType.grid}
        onChange={(e) => setViewLayout(e.currentTarget.value as ViewLayoutType)}
      >
        <Icon name="table-cells" title="Click to view as grid" />
      </ToggleButton>
    </ButtonGroup>
  )
}
